import Table from "../components/Table";
import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useMemo, useRef, useState } from "react";
import $ from "jquery";
import config from "../../../config";
import Pagination from "../../../components/Pagination";
import filterIcon from "../../../images/icons/filter.png";
import "../style.css";
import Swal from "sweetalert2";
import moment from "moment";
import Tippy from "@tippyjs/react";
import Filter from "../components/Filter";
import ExcelDownload from "../components/ExcelDownload";
import { useLocation } from "react-router-dom";

const getItemList = async (inputValue, callback) => {
  if (inputValue.toString().length > 2) {
    await $.post(
      `${config.apiUrl}/item/listItem`,
      JSON.stringify({
        is_active: 1,
        paginate: 0,
        item_name: inputValue.toString(),
      }),
      function (res) {
        callback(
          res.data.list.map((v) => {
            return {
              value: v.item_id,
              label: v.item_name,
            };
          })
        );
      }
    );
  } else {
    callback([]);
  }
};

const getItemCatList = async (inputValue, callback) => {
  if (inputValue.toString().length > 2) {
    await $.post(
      `${config.apiUrl}/itemCategory/listItemCategory`,
      JSON.stringify({
        is_active: 1,
        paginate: 0,
        item_cat_name: inputValue.toString(),
      }),
      function (res) {
        callback(
          res.data.list.map((v) => {
            return {
              value: v.item_cat_id,
              label: v.item_cat_name,
            };
          })
        );
      }
    );
  } else {
    callback([]);
  }
};

const StockMovement = (props) => {
  const [user, setUser] = useState({});
  const [pageSize, setPageSize] = useState(10);
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const location = useLocation();

  console.log("locationlocationlocationlocation", location.state);

  const getBranchList = async (inputValue, callback) => {
    let branches = props.branchList.filter((b) =>
      b.label
        .toString()
        .toLowerCase()
        .includes(inputValue.toString().toLowerCase())
    );
    callback(branches);
  };

  const getGodownList = async (inputValue, callback) => {
    await $.post(
      `${config.apiUrl}/godown/listGodown`,
      JSON.stringify({
        godown_name: inputValue,
        paginate: 0,
        is_active: 1,
        branch_id:
          filter.branch_id ||
          JSON.parse(localStorage.getItem("inventory"))?.userData
            ?.branch_data?.[0]?.branch_id,
      }),
      function (res) {
        if (res?.data?.count) {
          callback(
            res.data.list.map((v) => {
              return {
                value: v.godown_id,
                label: v.godown_name,
              };
            })
          );
        } else {
          callback([]);
        }
      }
    );
  };

  const isMounted = useRef(false);
  let getTransactionType = [
    { value: "1", label: "Purchase" },
    { value: "3", label: "Purchase Return" },
    { value: "2", label: "Challan" },
    { value: "4", label: "Challan Return" },
    { value: "6", label: "Stock In" },
    { value: "5", label: "Stock Out" },
  ];

  const filterList = [
    // {
    //   name: "branch_id",
    //   label: "Branch Name",
    //   type: "async_select",
    //   // required: [1, 2].includes(user.role_id),
    //   visible: [1, 2].includes(user.role_id),
    //   values: getBranchList,
    // },
    {
      name: "godown_id",
      label: "Godown Name",
      type: "async_select",
      values: getGodownList,
    },
    {
      name: "tran_type",
      label: "Transaction Type",
      type: "select-dropdown",
      values: getTransactionType,
    },
    {
      name: "item_id",
      label: "Item Name",
      type: "async_select",
      required: true,
      values: getItemList,
    },
    // {
    //   name: "item_cat_id",
    //   label: "Category",
    //   type: "async_select",
    //   values: getItemCatList,
    // },
    { name: "from_date", label: "From Date", type: "date", required: true },
    { name: "to_date", label: "To Date", type: "date", required: true },
  ];

  const columnList = [
    // {
    //   label: "Branch Name",
    //   value: "branch_name",
    //   visible: [1, 2].includes(user.role_id),
    // },
    { label: "Godown Name", value: "godown_name", visible: true },
    { label: "Item", value: "item_name", visible: true },
    { label: "Category", value: "item_cat_name", visible: true },
    { label: "Unit", value: "item_unit", visible: true },
    { label: "Description", value: "desc", visible: true },
    { label: "Type", value: "tran_type", visible: true },
    { label: "Qty ", value: "qty", visible: true },
    { label: "Trans No", value: "fid_1", visible: true },
    { label: "Trans Date", value: "trans_date", visible: true },
    { label: "", value: "is_active", visible: false },
  ];

  const [filter, setFilter] = useState(() => {
    let filters = {};
    filterList.forEach((list) => {
      if (list.name === "from_date" || list.name === "to_date") {
        filters[list.name] = moment().format("YYYY-MM-DD");
      } else {
        filters[list.name] = "";
      }
    });
    return filters;
  });

  const [locationDate, setLocationDate] = useState();
  const searchParams = new URLSearchParams(location?.search);

  const RowData = JSON.parse(decodeURIComponent(searchParams.get("RowData")));
  const FilterDate = JSON.parse(decodeURIComponent(searchParams.get("filter")));
  const TransType = JSON.parse(
    decodeURIComponent(searchParams.get("TransType"))
  );
  const [isInitialized, setIsInitialized] = useState(false);
  const [parsedParams, setParsedParams] = useState(null);

  useEffect(() => {
    if (!isInitialized) {
      const searchParams = new URLSearchParams(location.search);

      const RowData = JSON.parse(
        decodeURIComponent(searchParams.get("RowData"))
      );
      const FilterData = JSON.parse(
        decodeURIComponent(searchParams.get("filter"))
      );
      const TransType = JSON.parse(
        decodeURIComponent(searchParams.get("TransType"))
      );

      setFilter((prev) => ({
        ...prev,
        from_date: FilterData?.from_date || moment().format("YYYY-MM-DD"),
        to_date: FilterData?.to_date || moment().format("YYYY-MM-DD"),
        tran_type: TransType?.value,
        item_id: RowData?.item_id,
        item_name: RowData?.item_name,
        godown_id: RowData?.godown_id,
        godown_name: RowData?.godown_name,
        item_cat_id: RowData?.item_cat_id,
        item_cat_name: RowData?.item_cat_name,
      }));
      setParsedParams({
        RowData,
        filter: FilterData,
        TransType,
      });
      setIsInitialized(true);
    }
  }, [isInitialized]);

  useEffect(() => {
    if (isInitialized && filter.from_date && filter.to_date && filter.item_id) {
      getList();
    }
  }, [isInitialized]);

  // const memo = useMemo(() => {
  //   setFilter((pre) => ({
  //     ...pre,
  //     // from_date:
  //     //   location?.state?.filter?.from_date || moment().format("YYYY-MM-DD"),
  //     // to_date:
  //     //   location?.state?.filter?.to_date || moment().format("YYYY-MM-DD"),
  //     // tran_type: location?.state?.TransType?.value,
  //     // item_id: location?.state?.RowData?.item_id,
  //     // item_name: location?.state?.RowData?.item_name,
  //     // godown_id: location?.state?.RowData?.godown_id,
  //     // godown_name: location?.state?.RowData?.godown_name,

  //     from_date: FilterDate?.from_date || moment().format("YYYY-MM-DD"),
  //     to_date: FilterDate?.to_date || moment().format("YYYY-MM-DD"),
  //     tran_type: TransType?.value,
  //     item_id: RowData?.item_id,
  //     item_name: RowData?.item_name,
  //     godown_id: RowData?.godown_id,
  //     godown_name: RowData?.godown_name,
  //   }));

  //   return true;
  // }, [location, searchParams]);

  // useEffect(() => {
  //   if (filter.from_date && filter.to_date && filter.item_id) {
  //     getList();
  //   }
  // }, [memo]);

  const [column, setColumn] = useState(() => columnList);
  console.log("filterfilter", filter);
  useEffect(() => {
    setColumn(() => columnList);
  }, [user]);
  const [row, setRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [showFilter, setShowFilter] = useState(true);
  const [showLoading, setShowLoading] = useState(false);

  console.log("rowrow", row);

  const getList = async () => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return;
    }
    if (user?.role_id === 3 || user?.role_id === 4) {
      filter.branch_id = JSON.parse(
        localStorage.getItem("inventory")
      )?.userData?.branch_data?.[0]?.branch_id;
    }
    // if (!filter?.branch_id) {
    //   Swal.fire("Error", "Branch Name is Required");
    //   return;
    // }
    if (!filter?.item_id) {
      Swal.fire("Error", "Item Name is Required");
      return;
    }

    setShowLoading(true);
    await $.post(
      `${config.apiUrl}/report/listStockMovement`,
      JSON.stringify({
        ...filter,
        paginate: 1,
        is_active: 1,
        page_no: currentPage - 1,
        page_size: pageSize,
      })
    )
      .done((res) => {
        if (res?.data?.list?.length > 0) {
          let cols = columnList.map((col) => col.value);
          setRow(() => {
            let resArr = res?.data?.list || [];
            // "Opening",
            // "Closing",
            let tranType = [
              "Opening",
              "Purchase",
              "Challan",
              "Purchase Rtn",
              "Challan Rtn",
              "Stock Out",
              "Stock In",
              "Closing",
            ];
            let arr = [];
            resArr?.forEach((r, i) => {
              // if (i + (currentPage - 1) * 10 === 0) {
              // let uniqueGodown = [];
              // resArr?.forEach((x) => {
              //   if (
              //     !uniqueGodown
              //       .map((y) => y.godown_name)
              //       .includes(x.godown_name)
              //   ) {
              //     uniqueGodown.push({
              //       branch_name: x?.branch_name || "",
              //       godown_name: x?.godown_name || "",
              //       item_name: x?.item_name || "-",
              //       item_unit: x?.item_unit || "-",
              //       desc: "Opening Stock",
              //       tran_type: tranType?.[0] || "",
              //       // qty: `${x?.op_st?.toFixed(2) || 0} (${(x?.op_st - x?.challan_qty_op).toFixed(2)})`,
              //       qty: `${Number(x?.op_st).toFixed(4) || 0}`,
              //       fid_1: "",
              //       trans_date:
              //         moment(x?.trans_date)?.format("DD-MM-YYYY") || "",
              //     });
              //   }
              // });
              // arr.push(...uniqueGodown);
              // }
              arr.push({
                branch_name: r?.branch_name || "",
                godown_name: r?.godown_name || "",
                item_name: r?.item_name || "-",
                item_cat_name: r?.item_cat_name || "-",
                item_unit: r?.item_unit || "-",
                desc: r?.party_name || "",
                tran_type: tranType?.[r?.tran_type] || "",
                // qty: `${r?.qty?.toFixed(2) || 0} (${r?.challan_qty})`,
                qty: `${Number(r?.qty).toFixed(4) || 0}`,
                // qty: r?.qty?.toFixed(2) || 0,
                fid_1: r?.fid_1 || "",
                trans_date:
                  moment(r?.trans_date).utc().format("DD-MM-YYYY") || "",
                is_active: r?.is_active,
                trans_id: r?.trans_id || "",
              });
              // if (i + (currentPage - 1) * 10 === res?.data?.count - 1) {
              //   let uniqueGodown = [];
              //   resArr.forEach((x) => {
              //     if (
              //       !uniqueGodown
              //         .map((y) => y.godown_name)
              //         .includes(x.godown_name)
              //     ) {
              //       uniqueGodown.push({
              //         branch_name: x?.branch_name || "",
              //         godown_name: x?.godown_name || "",
              //         item_name: x?.item_name || "-",
              //         item_unit: x?.item_unit || "-",
              //         desc: "Closing Stock",
              //         tran_type: tranType?.[7] || "",
              //         // qty: `${x?.cl_st?.toFixed(2) || 0} (${(x?.cl_st - x?.challan_qty_op - x?.challan_qty_cl).toFixed(2)})`,
              //         qty: Number(x?.cl_st).toFixed(4) || 0,
              //         fid_1: "",
              //         trans_date:
              //           moment(filter?.to_date || x?.trans_date)?.format(
              //             "DD-MM-YYYY"
              //           ) || "",
              //       });
              //     }
              //   });
              //   arr.push(...uniqueGodown);
              // }
            });
            return arr;
          });
          setTotalPage(() => res?.data?.count || 0);
          setCurrentPage(() => currentPage);
        } else {
          setTotalPage(() => 0);
          setCurrentPage(() => 1);
          setRow(() => []);
        }
        setShowLoading(false);
      })
      .fail((err) => {
        Swal.fire(
          "",
          err?.responseJSON?.data?.message || err?.responseJSON?.message
        );
        setShowLoading(false);
      });
  };

  const clearList = () => {
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        filters[list.name] = "";
      });
      return filters;
    });
    setTotalPage(() => 0);
    setCurrentPage(() => 1);
    setRow(() => []);
  };

  const validateDownload = (filter) => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return false;
    }
    if (user?.role_id === 3 || user?.role_id === 4) {
      filter.branch_id = JSON.parse(
        localStorage.getItem("inventory")
      )?.userData?.branch_data?.[0]?.branch_id;
    }
    // if (!filter?.branch_id) {
    //   Swal.fire("Error", "Branch Name is Required");
    //   return false;
    // }
    if (!filter?.item_id) {
      Swal.fire("Error", "Item Name is Required");
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (isMounted.current) getList();
    isMounted.current = true;
  }, [currentPage]);

  const changePageSize = (e) => {
    const newSize = e.target.value;
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (row.length > 0) {
      getList();
    }
  }, [pageSize]);

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-2" id="ledger">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col-md">
                  <Breadcrumb path={["Stock Movement"]} />
                </div>

                <div className="col-md text-end">
                  <select value={pageSize} onChange={(e) => changePageSize(e)}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <Tippy content="Filter" trigger="mouseenter">
                    <img
                      src={filterIcon}
                      className="img-fluid mx-2 icon"
                      width="35px"
                      height="35px"
                      alt=""
                      role="button"
                      onClick={(e) => setShowFilter(!showFilter)}
                    />
                  </Tippy>

                  <ExcelDownload
                    validate={validateDownload}
                    filter={filter}
                    filename="StockMovement"
                    url={`${config.apiUrl}/report/listStockMovement`}
                  />
                </div>
              </div>

              <Filter
                show={showFilter}
                filterList={filterList}
                showLoading={showLoading}
                locationDate={parsedParams}
                handler={{ getList, clearList, state: { filter, setFilter } }}
              />

              <Table tableData={{ column, row }} handler={{ getList }} />

              <div className="row mt-4">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / Number(pageSize))}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default StockMovement;
